export const COMPONENT_NAME = "settings-tabs";
